import { useAuthentication } from '@alexandrainst/plana-react-api'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { sentryUserFor } from './sentryUser'

/**
 * Keeps the Sentry user identity in sync with the (possibly rehydrated) auth
 * state, so every captured event — `[update-health]` reports, manual error
 * reports, crashes — carries the backend `userid`.
 *
 * Why a hook and not only the sign-in callback: these installed PWAs restore
 * persisted auth on launch and almost never re-run the interactive login, so the
 * old `Sentry.setUser` in the sign-in path almost never fired — leaving prod
 * events with no user (`count_unique(user) === 0`) and no way to count distinct
 * affected users or join `[update-health]` errors to the backend clientlog.
 * Mount once per shell.
 */
export const useSentryUser = () => {
  const {
    state: { authenticated, userid },
  } = useAuthentication()

  useEffect(() => {
    Sentry.setUser(sentryUserFor(authenticated, userid))
  }, [authenticated, userid])
}
